import React from "react";
import classnames from "classnames";

/**
 * Label on the left, value on the right: `${block}__row`, `__row-label`
 * and `__row-value` of the modal's BEM block.
 *
 * @param {object} props
 * @param {string} props.block e.g. "trade-details"
 * @param {React.ReactNode} props.label
 * @param {React.ReactNode} props.children
 * @param {string} [props.className] modifier of the row
 */
export const DetailRow = ({ block, label, children, className }) => (
  <div className={classnames(`${block}__row`, className)}>
    <span className={`${block}__row-label`}>{label}</span>
    <span className={`${block}__row-value`}>{children}</span>
  </div>
);
